import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconStatusSuccess = createIcon({
  viewBox: '0 0 48 48',
  path: (
    <g fill="none" fillRule="evenodd">
      <g>
        <circle
          cx="24"
          cy="24"
          r="16.125"
          fill="#3EA69B"
          stroke="#FFF"
          strokeWidth="3.75"
        />
        <circle cx="24" cy="24" r="17.25" stroke="#3EA69B" strokeWidth="1.5" />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M29.472 19.847c.464-.463 1.216-.463 1.68 0 .464.462.464 1.21 0 1.673l-8.168 8.133c-.464.463-1.217.463-1.68 0l-4.456-4.436c-.464-.462-.464-1.211 0-1.673.464-.462 1.216-.462 1.68 0l3.616 3.6 7.328-7.297z"
      />
    </g>
  ),
});

export default IconStatusSuccess;
